import { render, staticRenderFns } from "./product-toppings-list.vue?vue&type=template&id=2f34e113&scoped=true"
import script from "./product-toppings-list.vue?vue&type=script&lang=js"
export * from "./product-toppings-list.vue?vue&type=script&lang=js"
import style0 from "./product-toppings-list.vue?vue&type=style&index=0&id=2f34e113&prod&lang=scss&scoped=true&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "2f34e113",
  null
  
)

export default component.exports